export const courseSelector = (state) => state.course.data;
export const courseProgressSelector = (state) => state.course.progress;
export const courseQuizResultSelector = (state) => state.course.quizResults;
export const courseFeedbackResultSelector = (state) => state.course.feedback;
export const moduleByIndexSelector = (state, index) =>
  state.course.data?.modules?.[index];
